import { ReactNode } from "react";
import { useNeumorphicTheme } from "@/contexts/NeumorphicThemeContext";
import { cn } from "@/lib/utils";

interface NeumorphicContainerProps {
  children: ReactNode;
  className?: string;
}

const NeumorphicContainer = ({ children, className = "" }: NeumorphicContainerProps) => {
  let theme = "dark";
  try {
    const themeContext = useNeumorphicTheme();
    theme = themeContext.theme;
  } catch {
    // Not within NeumorphicThemeProvider, use default
  }

  return (
    <div className={cn(
      "min-h-screen transition-colors duration-500",
      theme === "dark" ? "bg-[#0f0f0f] text-white" : "bg-[#f5f5f5] text-black",
      className
    )}>
      {children}
    </div>
  );
};

export default NeumorphicContainer;
